export const Titles = [
  {
    title: 'general information',
    event: 'pg_act_nma_landing_everythingyouneed_generalinformation',
  },
  {
    title: 'categories',
    event: 'pg_act_nma_landing_everythingyouneed_categories',
  },
  {
    title: 'submission process',
    event: 'pg_act_nma_landing_everythingyouneed_submissionprocess',
  },
  {
    title: 'judging process',
    event: 'pg_act_nma_landing_everythingyouneed_judgingprocess',
  },
  {
    title: 'awards & recognition',
    event: 'pg_act_nma_landing_everythingyouneed_awards&recognition',
  },
  {
    title: 'technical issues & support',
    event: 'pg_act_nma_landing_everythingyouneed_technicalissues&support',
  },
  {
    title: "people's vote",
    event: 'pg_act_nma_landing_everythingyouneed_peoplesvote',
  },
]
